import React from 'react';
import cx from 'classnames';
import T from 'i18n-react';
import Link from 'next/link';

import { Button } from '@motorway/mw-highway-code';

import styles from '../StaticContents.module.scss';

const AlreadyActivated = () => (
	<div className={cx(styles.staticContents, styles.container, styles.center)}>
		<h1>{T.translate('alreadyActivated.title')}</h1>
		<div>
			<p>
				{T.translate('alreadyActivated.message')}
				<Link as="/contact-us" className="mw-link" href="/static_page">
					{T.translate('alreadyActivated.contactUs')}
				</Link>
			</p>
		</div>
		<br />
		<Link legacyBehavior passHref as="/signin" href="/signin">
			<Button fullWidth as="a" label={T.translate('alreadyActivated.signIn')} />
		</Link>
	</div>
);

export default AlreadyActivated;
